import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {
  renderImage,
  renderName,
  renderRole,
  renderSocialNetworks,
  TYPE_CREDIT,
} from '../BioHelpers';

class CastItem extends Component {
  renderContent() {
    const { breakpoint, data, isDetail, theme: style } = this.props;
    return (
      <div className={style.wrapper} data-test="web-cast-item-content">
        {renderImage({ style, data, isDetail, breakpoint })}
        {renderName({ style, data, isDetail })}
        {renderRole({ style, data })}
      </div>
    );
  }

  renderLinkableContent() {
    const { data, url, selectMenuItemEvent, theme } = this.props;
    const name = _.get(data, 'name');
    const role = _.get(data, 'role');
    return (
      <Link
        className={theme.linkableWrapper}
        onClick={() => {
          selectMenuItemEvent({ title: name, subtitle: role });
        }}
        to={url}
        data-test="web-cast-item-link"
      >
        {this.renderContent()}
      </Link>
    );
  }

  render() {
    const { data, url, theme: style } = this.props;
    if (!data) return null;

    const { '@type': type } = data;
    if (type !== TYPE_CREDIT) return null;

    const content = url ? this.renderLinkableContent() : this.renderContent();
    const socialNetworks = renderSocialNetworks({ style, data });

    return (
      <div className={style.castItem} data-test="web-cast-item">
        {content}
        {socialNetworks}
      </div>
    );
  }
}

CastItem.defaultProps = {
  data: null,
  isDetail: false,
  url: null,
  selectMenuItemEvent: () => {},
};

CastItem.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  data: PropTypes.shape({
    '@type': PropTypes.string,
    images: PropTypes.shape({}),
    name: PropTypes.string,
    role: PropTypes.string,
    facebookUrl: PropTypes.string,
    twitterUrl: PropTypes.string,
  }),
  isDetail: PropTypes.bool,
  url: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  selectMenuItemEvent: PropTypes.func,
};

export default CastItem;
